<template>
  <div class="static-tasks-container">
    <div v-if="isFeedMode" class="next-task-button-wrapper">
      <button @click="goToNextTask" class="next-task-button">
        <span class="button-icon">➡️</span>
        <span>מעבר למשימה הבאה</span>
      </button>
    </div>

    <!-- Morning Emails -->
    <div v-if="taskId === 'morning_emails'" class="task-card">
      <div class="task-icon">📧</div>
      <h2 class="task-title">מיילים בוקר</h2>
      <div class="task-content">
        <p>יש לעבוד על תיבת המייל, לעדכן, לבצע משימות ולתייק את המיילים שטופלו.</p>
        <p class="task-responsibility">אחריות על המייל וקבלת משרות חדשות לאורך יום העבודה</p>
      </div>
    </div>

    <!-- Noon Emails -->
    <div v-if="taskId === 'noon_emails'" class="task-card">
      <div class="task-icon">📧</div>
      <h2 class="task-title">מיילים צהריים</h2>
      <div class="task-content">
        <p>יש לעבוד על תיבת המייל, לעדכן, לבצע משימות ולתייק את המיילים שטופלו.</p>
      </div>
    </div>

    <!-- Evening Emails -->
    <div v-if="taskId === 'evening_emails'" class="task-card">
      <div class="task-icon">📧</div>
      <h2 class="task-title">מיילים ערב</h2>
      <div class="task-content">
        <p>יש לעבוד על תיבת המייל, לעדכן, לבצע משימות ולתייק את המיילים שטופלו.</p>
      </div>
    </div>

    <!-- Recruiting New Employers -->
    <div v-if="taskId === 'recruit_employers'" class="task-card">
      <div class="task-icon">🏢</div>
      <h2 class="task-title">גיוס מעסיקים חדשים</h2>
      <div class="task-content">
        <p>גיוס מעסיקים חדשים</p>
      </div>
    </div>

    <!-- Collections -->
    <div v-if="taskId === 'collections'" class="task-card">
      <div class="task-icon">💰</div>
      <h2 class="task-title">גבייה</h2>
      <div class="task-content">
        <p>גבייה</p>
      </div>
    </div>

    <!-- Project 1000 -->
    <div v-if="taskId === 'project_1000'" class="task-card">
      <div class="task-icon">🎯</div>
      <h2 class="task-title">פרויקט ה-1000</h2>
      <div class="task-content">
        <p>פרויקט ה-1000</p>
      </div>
    </div>

    <!-- Lead Board Tracking -->
    <div v-if="taskId === 'lead_board_tracking'" class="task-card">
      <div class="task-icon">📊</div>
      <h2 class="task-title">מעקב לוח לידים</h2>
      <div class="task-content">
        <p>מעקב לוח לידים</p>
        <a
          :href="leadBoardUrl"
          class="lead-board-link"
        >
          <span class="link-icon">🔗</span>
          <span>פתח לוח לידים</span>
          <span class="external-icon">↗</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaticTasks',
  props: {
    taskId: {
      type: String,
      required: true
    },
    isFeedMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    leadBoardUrl () {
      // Use current origin to construct the URL dynamically
      return `${window.location.origin}/admin/offers?statuses=received_proposal,interview&sort=-updated_at`
    }
  },
  methods: {
    goToNextTask () {
      this.$emit('go-to-next-task')
    }
  }
}
</script>

<style scoped>
.static-tasks-container {
  padding: 12px;
  background: #ffffff;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

/* Next Task Button */
.next-task-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.next-task-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.next-task-button:hover {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
}

.next-task-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.button-icon {
  font-size: 1.3rem;
  animation: slideRight 1.5s ease-in-out infinite;
}

@keyframes slideRight {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
}

.task-card {
  width: 100%;
  max-width: 400px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
  color: white;
  text-align: center;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.task-icon {
  font-size: 2.5rem;
  margin-bottom: 12px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.task-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.task-content {
  font-size: 0.95rem;
  line-height: 1.6;
}

.task-content p {
  margin: 8px 0;
  font-weight: 500;
}

.task-responsibility {
  margin-top: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-weight: 600;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.lead-board-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.lead-board-link:hover {
  background: rgba(255, 255, 255, 0.35);
  border-color: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.link-icon {
  font-size: 1.1rem;
}

.external-icon {
  font-size: 1rem;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 768px) {
  .task-card {
    padding: 15px;
  }

  .task-icon {
    font-size: 2rem;
  }

  .task-title {
    font-size: 1.2rem;
  }

  .task-content {
    font-size: 0.9rem;
  }

  .lead-board-link {
    padding: 8px 15px;
    font-size: 0.9rem;
  }
}
</style>
